import { ImageUpaloadToolbar } from './ImageUploadToolbar';
import { InlineStyleToolBar } from './InlineToolbar';
import { LinkToolbar } from './LinkToolbar';

export const editorConfig = {
  options: ['inline', 'link', 'image'],
  inline: {
    component: InlineStyleToolBar,
  },
  link: {
    inDropdown: true,
    className: 'linkUnlink',
    component: LinkToolbar,
    popupClassName: 'link-popup',
    showOpenOptionOnHover: true,
    defaultTargetOption: '_self',
    options: ['link', 'unlink'],
    link: { className: 'toolbar-item' },
    unlink: { className: 'toolbar-item' },
    linkCallback: undefined,
  },
  image: {
    component: ImageUpaloadToolbar,
    className: 'toolbar-item image',
    icon: '/icons/image.svg',
    popupClassName: 'link-popup',
    image: { className: 'image' },
    urlEnabled: true,
    uploadEnabled: true,
    alignmentEnabled: false,
    uploadCallback: undefined,
    previewImage: true,
    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
    alt: { present: false, mandatory: false },
    defaultSize: {
      height: 'auto',
      width: 'auto',
    },
  },
};
